module.exports = __webpack_public_path__ + "img/kh.b4e384b4.svg";